<template>
  <div id="award-type-create" class="professional-recognition-form">
    <!-- Professional Overlay Loading -->
    <v-overlay :value="OverlayLoadingFlag" class="professional-overlay">
      <div class="loading-container">
        <v-progress-circular
          indeterminate
          size="64"
          width="4"
          color="#1976d2"
        ></v-progress-circular>
        <p class="loading-text mt-4">
          Processing your recognition application...
        </p>
      </div>
    </v-overlay>

    <!-- Professional Main Container -->
    <v-card class="main-form-container" elevation="8">
      <!-- Professional Header Section -->
      <v-card-title class="professional-form-header pa-6">
        <div class="header-content">
          <div class="title-section">
            <div class="main-title-wrapper">
              <v-icon size="32" color="#1976d2" class="mr-3"
                >mdi-trophy-award</v-icon
              >
              <div class="title-text">
                <h1 class="form-main-title">{{ PageTitle }}</h1>
              </div>
            </div>
          </div>
          <div class="action-buttons">
            <v-btn
              @click="closePrompt"
              color="#757575"
              elevation="2"
              rounded
              class="action-btn white--text"
            >
              <v-icon left size="18">mdi-close</v-icon>
              Close
            </v-btn>
          </div>
        </div>
      </v-card-title>

      <!-- Professional Content Container -->
      <v-card-text class="form-main-content pa-6">
        <v-container>
          <!-- Professional Loading Section -->
          <div class="form-loading-section" v-if="LoadingFlag">
            <div class="loading-wrapper">
              <v-progress-circular
                indeterminate
                color="#1976d2"
                size="48"
                width="4"
              ></v-progress-circular>
              <p class="loading-text mt-4">Loading recognition details...</p>
            </div>
          </div>

          <!-- Professional Form Container -->
          <v-form
            ref="form1"
            v-model="valid1"
            lazy-validation
            v-on:submit.prevent="getCurrentDateTime"
            class="professional-form"
          >
            <div class="form-content-wrapper" v-if="recordData != ''">
              <!-- Category Details Card -->
              <v-card class="details-card mb-6" elevation="3">
                <v-card-title class="details-header">
                  <v-icon size="24" color="#1976d2" class="mr-3"
                    >mdi-clipboard-text</v-icon
                  >
                  <span class="section-title">Category Details</span>
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">Category Title</label>
                        <p class="detail-value">
                          {{ recordData.CategoryTitle }}
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">Category Description</label>
                        <p class="detail-value">
                          {{ recordData.CategoryDescription }}
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">Category Type</label>
                        <p class="detail-value">
                          {{ recordData.CategoryTypeTxt }}
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- LO Details Card -->
              <v-card class="details-card mb-6" elevation="3">
                <v-card-title class="details-header">
                  <v-icon size="24" color="#1976d2" class="mr-3"
                    >mdi-office-building</v-icon
                  >
                  <span class="section-title">LO Details</span>
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">LO Name</label>
                        <p class="detail-value">{{ LomDetails.LomName }}</p>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label">President Name</label>
                        <p
                          class="detail-value"
                          v-if="LomDetails && LomDetails.President"
                        >
                          {{ LomDetails.President.LomPresidentFullName }}
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4">
                      <div class="detail-item">
                        <label class="detail-label"
                          >President Membership Id</label
                        >
                        <p
                          class="detail-value"
                          v-if="LomDetails && LomDetails.President"
                        >
                          {{ LomDetails.President.LomPresidentMembershipId }}
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Description and Member Selection Card -->
              <v-card class="input-card mb-6" elevation="3">
                <v-card-title class="details-header">
                  <v-icon size="24" color="#1976d2" class="mr-3"
                    >mdi-text-box</v-icon
                  >
                  <span class="section-title">Recognition Details</span>
                </v-card-title>
                <v-card-text class="pa-6">
                  <v-row>
                    <v-col cols="12" md="12">
                      <div class="input-section">
                        <h4 class="input-label">Description</h4>
                        <v-textarea
                          v-model="Description"
                          placeholder="Enter recognition description..."
                          required
                          outlined
                          dense
                          rows="4"
                          prepend-inner-icon="mdi-text"
                        ></v-textarea>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" v-if="recordData.CategoryType == 2">
                      <div class="input-section">
                        <h4 class="input-label">
                          <span class="required-indicator">*</span> Select
                          Member
                        </h4>
                        <v-autocomplete
                          @change="getMemberDetails"
                          :reduce="(option) => option.value"
                          :loading="MemberIdOptionsLoading"
                          :items="MemberIdOptions"
                          :rules="MemberIdRules"
                          v-model="MemberId"
                          required
                          outlined
                          dense
                          clearable
                          placeholder="Search and select member..."
                          prepend-inner-icon="mdi-account-search"
                        >
                          <template v-slot:selection="{ item }">
                            <div class="member-selection-item">
                              <img
                                class="member-avatar mr-2"
                                width="32"
                                height="32"
                                :src="item.photo"
                              />
                              {{ item.text }}
                            </div>
                          </template>
                          <template v-slot:item="{ item }">
                            <div class="member-dropdown-item">
                              <img
                                class="member-avatar mr-3"
                                width="40"
                                height="40"
                                :src="item.photo"
                              />
                              <span>{{ item.text }}</span>
                            </div>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-col>
                  </v-row>

                  <!-- Member Details Display -->
                  <v-row v-if="MemberId > 0" class="mt-4">
                    <v-col cols="12">
                      <v-card class="member-details-card" outlined>
                        <v-card-text class="pa-4">
                          <v-row align="center">
                            <v-col cols="12" sm="3" md="2" class="text-center">
                              <v-avatar size="100">
                                <img :src="member.photo" alt="Member Photo" />
                              </v-avatar>
                            </v-col>
                            <v-col cols="12" sm="9" md="10">
                              <v-row>
                                <v-col cols="12" sm="6" md="3">
                                  <div class="member-detail-item">
                                    <label class="member-label"
                                      >Member Name</label
                                    >
                                    <p class="member-value">
                                      {{ member.member_name }}
                                    </p>
                                  </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                  <div class="member-detail-item">
                                    <label class="member-label"
                                      >Membership Id</label
                                    >
                                    <p class="member-value">
                                      {{ member.membership_id }}
                                    </p>
                                  </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                  <div class="member-detail-item">
                                    <label class="member-label"
                                      >Date of Birth</label
                                    >
                                    <p class="member-value">
                                      {{ member.member_dob }}
                                    </p>
                                  </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                  <div class="member-detail-item">
                                    <label class="member-label"
                                      >Mobile No</label
                                    >
                                    <p class="member-value">
                                      {{ member.mobile_no }}
                                    </p>
                                  </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                  <div class="member-detail-item">
                                    <label class="member-label">Email Id</label>
                                    <p class="member-value">
                                      {{ member.email_id }}
                                    </p>
                                  </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="8">
                                  <div class="member-detail-item">
                                    <label class="member-label">Address</label>
                                    <p class="member-value">
                                      {{ member.address_txt }}
                                    </p>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Attachments Card -->
              <v-card class="attachments-card mb-6" elevation="3" v-if="recordData.CategoryType != 3">
                <v-card-title class="details-header">
                  <div class="attachments-header-content">
                    <div class="attachments-title-section">
                      <v-icon size="24" color="#1976d2" class="mr-3"
                        >mdi-paperclip</v-icon
                      >
                      <span class="section-title">Attachments</span>
                      <small class="ml-2 grey--text"
                        >(max - {{ CategoryMaxCount }})</small
                      >
                    </div>
                    <v-btn
                      color="#1976d2"
                      icon
                      @click="addNewRow()"
                      v-if="AllProject.length < CategoryMaxCount"
                      class="add-attachment-btn"
                    >
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                  </div>
                </v-card-title>
                <v-card-text class="pa-6">
                  <template v-if="AllProject.length > 0">
                    <v-row>
                      <v-col
                        v-for="(data, index) in AllProject"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                        :key="index"
                      >
                        <v-card class="attachment-item-card" elevation="2">
                          <v-card-text class="pa-3">
                            <div class="attachment-actions">
                              <v-btn
                                v-if="data.EventId != ''"
                                icon
                                small
                                color="red"
                                @click="deleteRow(index)"
                                class="delete-btn"
                              >
                                <v-icon size="20">mdi-delete</v-icon>
                              </v-btn>
                            </div>
                            <div class="event-images mb-3">
                              <viewer rebuild :images="data.EventPhoto">
                                <div class="images-grid">
                                  <img
                                    class="event-image"
                                    width="60"
                                    height="60"
                                    :src="src"
                                    :key="src"
                                    v-for="src in data.EventPhoto"
                                  />
                                </div>
                              </viewer>
                            </div>
                            <div class="event-details">
                              <div class="detail-row mb-2">
                                <v-icon size="14" color="#666" class="mr-1"
                                  >mdi-calendar</v-icon
                                >
                                <span class="detail-value">{{
                                  data.EventDate
                                }}</span>
                              </div>
                              <div class="detail-row mb-2">
                                <v-icon size="14" color="#666" class="mr-1"
                                  >mdi-briefcase</v-icon
                                >
                                <span class="detail-value">{{
                                  data.PortfolioName
                                }}</span>
                              </div>
                              <div class="detail-row">
                                <v-icon size="14" color="#666" class="mr-1"
                                  >mdi-calendar-star</v-icon
                                >
                                <span class="detail-value">{{
                                  data.EventName
                                }}</span>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </template>
                  <div v-else class="no-attachments-state">
                    <v-icon size="64" color="#ccc">mdi-paperclip-off</v-icon>
                    <p class="mt-3 grey--text">No attachments added yet</p>
                  </div>
                </v-card-text>
              </v-card>

              <!-- File Upload Card for Category Type 3 -->
              <v-card class="attachments-card mb-6" elevation="3" v-if="recordData.CategoryType == 3">
                <v-card-title class="details-header">
                  <div class="attachments-header-content">
                    <div class="attachments-title-section">
                      <v-icon size="24" color="#1976d2" class="mr-3"
                        >mdi-file-upload</v-icon
                      >
                      <span class="section-title">Upload Files</span>
                      <small class="ml-2 grey--text"
                        >(max - {{ CategoryMaxCount }} images)</small
                      >
                    </div>
                  </div>
                </v-card-title>
                <v-card-text class="pa-6">
                  <!-- File Upload Input -->
                  <v-row v-if="UploadedFiles.length < CategoryMaxCount">
                    <v-col cols="12">
                      <v-file-input
                        @change="handleFileUpload"
                        accept="image/*"
                        prepend-icon="mdi-camera"
                        label="Click to upload image"
                        outlined
                        dense
                        clearable
                        show-size
                        :disabled="UploadedFiles.length >= CategoryMaxCount"
                      ></v-file-input>
                    </v-col>
                  </v-row>

                  <!-- Uploaded Files Preview -->
                  <template v-if="UploadedFiles.length > 0">
                    <v-row>
                      <v-col
                        v-for="(file, index) in UploadedFiles"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                        :key="index"
                      >
                        <v-card class="attachment-item-card" elevation="2">
                          <v-card-text class="pa-3">
                            <div class="attachment-actions">
                              <v-btn
                                icon
                                small
                                color="red"
                                @click="removeUploadedFile(index)"
                                class="delete-btn"
                              >
                                <v-icon size="20">mdi-delete</v-icon>
                              </v-btn>
                            </div>
                            <div class="file-preview mb-3">
                              <img
                                :src="file.FilePreview"
                                class="uploaded-image"
                                width="100%"
                                height="150"
                                style="object-fit: cover; border-radius: 8px;"
                              />
                            </div>
                            <div class="file-details">
                              <div class="detail-row">
                                <v-icon size="14" color="#666" class="mr-1"
                                  >mdi-file</v-icon
                                >
                                <span class="detail-value text-truncate">{{
                                  file.FileName
                                }}</span>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </template>
                  <div v-else class="no-attachments-state">
                    <v-icon size="64" color="#ccc">mdi-file-upload-outline</v-icon>
                    <p class="mt-3 grey--text">No files uploaded yet</p>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Submit Section -->
              <div class="submit-section">
                <v-card class="submit-card" elevation="3">
                  <v-card-text class="text-center pa-6">
                    <div class="submit-info mb-4">
                      <v-icon size="48" color="#1976d2">mdi-send</v-icon>
                      <h3 class="submit-title mt-3">Ready to Submit?</h3>
                      <p class="submit-description">
                        Review your information and submit your recognition
                        application
                      </p>
                    </div>
                    <div class="action-buttons">
                      <v-btn
                        :disabled="!valid1"
                        @click.prevent="confirmAlert(4)"
                        :loading="SaveFlag"
                        elevation="8"
                        rounded
                        large
                        color="#f3722c"
                        class="submit-btn white--text mr-3"
                      >
                        <v-icon left>mdi-content-save</v-icon>
                        Save
                      </v-btn>
                      <v-btn
                        :disabled="!valid1"
                        @click.prevent="confirmAlert(3)"
                        :loading="SubmitFlag"
                        elevation="8"
                        rounded
                        large
                        color="#43aa8b"
                        class="submit-btn white--text mr-3"
                      >
                        <v-icon left>mdi-check-circle</v-icon>
                        Final Submit
                      </v-btn>
                      <v-btn
                        @click="closePrompt"
                        elevation="8"
                        rounded
                        large
                        color="#757575"
                        class="submit-btn white--text"
                      >
                        <v-icon left>mdi-close-circle</v-icon>
                        Close
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addAttachmentPrompt" persistent max-width="70%">
      <answer-attachment-create
        pageTitle="Add Project Details"
        :addAttachmentPrompt="addAttachmentPrompt"
        @hideAddAttachmentPrompt="hideAddAttachmentPrompt($event)"
        v-if="addAttachmentPrompt"
      ></answer-attachment-create>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import AnswerAttachmentCreate from "@/view/pages/erp/jci-award/np-recognition/AnswerAttachmentCreate.vue";

export default {
  mixins: [common],
  components: {
    AnswerAttachmentCreate,
  },
  props: {
    addRecordPrompt: {
      required: true,
      type: Boolean,
    },
    recordData: {
      required: true,
    },
    recognitionDetails: {
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SaveFlag: false,
      SubmitFlag: false,
      OverlayLoadingFlag: false,

      UploadFlag: false,
      ResultFlag: false,

      Status: "",
      NpRecognitionStartDate: "",
      NpRecognitionEndDate: "",

      StartDateFlag: false,
      EndDateFlag: false,

      CurrentDate: "",
      CurrentTime: "",
      CurrentAmPm: "",

      record: {},
      LomDetails: {},
      member: {},

      AllProject: [],

      Description: "",

      addAttachmentPrompt: false,

      LomCode: 0,
      CategoryMaxCount: 0,
      CategoryType: 0,
      UploadedFiles: [],

      MemberIdRules: [(v) => !!v || "Member is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      YearCode: "",

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        this.YearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;
        this.pageData();
      }
    },
    MemberIdOptions: function () {
      this.MemberIdOptionsLoading = false;
    },
    MemberId: function () {
      console.log("watch MemberId");
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log({ member });
      }
    },
    LomCode: function () {
      console.log("Watch LomCode Called");
      this.getMemberIdOptions();
    },
  },
  mounted() {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "np_recognition",
        Action: "create",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideAddRecordPrompt", this.ResultFlag);
    },
    pageData() {
      console.log("pageData called");
      console.log(
        "recognitionDetails = " + JSON.stringify(this.recognitionDetails)
      );
      console.log("recordData =" + JSON.stringify(this.recordData));
      this.CategoryMaxCount = this.recordData.CategoryMaxCount;
      this.CategoryType = this.recordData.CategoryType;
      this.getLomDetails();
      // this.getMemberIdOptions();
    },
    getLomDetails() {
      console.log("getLomDetails called");
      this.OverlayLoadingFlag = true;

      var upload = {
        UserInterface: 2,
      };
      console.log("upload=" + JSON.stringify(upload));

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      var add_url = server_url + "api/lom/show";
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      this.LoadingFlag = true;
      this.LomDetails = {};

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.LoadingFlag = false;
          thisIns.OverlayLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);
          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.LomDetails = records;
            thisIns.LomCode = records.LomId;
            console.log("LomCode =", thisIns.LomCode);
          } else {
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.LoadingFlag = false;
          thisIns.OverlayLoadingFlag = false;
        });
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      this.MemberIdOptionsLoading = true;
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 7,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getMemberDetails() {
      console.log("getMemberDetails called");
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log("member=" + JSON.stringify(member));
        this.member = member;
      }
    },
    addNewRow(tr) {
      console.log("addNewRow called");
      console.log({ tr });
      this.addAttachmentPrompt = true;
    },
    hideAddAttachmentPrompt(tr) {
      console.log("hideAddAttachmentPrompt called");
      this.addAttachmentPrompt = false;
      console.log("tr=" + JSON.stringify(tr));

      var id = tr.EventId;
      console.log({ id });

      if (id > 0) {
        var n1 = this.AllProject.length;
        var n2 = this.CategoryMaxCount;
        console.log({ n1 }, { n2 });

        if (n1 < n2) {
          this.AllProject.push({
            EventId: tr.EventId,
            EventName: tr.EventName,
            EventDate: tr.EventDate,
            PortfolioName: tr.PortfolioName,
            EventPhoto: tr.EventPhoto,
          });
        } else {
          var Message = "Attachment Maximum Count reached its limit.";
          this.sweetAlert("error", Message, false);
        }
      }
      console.log("AllProject =" + JSON.stringify(this.AllProject));
    },
    deleteRow(index) {
      console.log("deleteRow called");
      console.log({ index });
      if (index > -1) {
        this.AllProject.splice(index, 1);
      }
      console.log("AllProject =" + JSON.stringify(this.AllProject));
    },
    handleFileUpload(file) {
      console.log("handleFileUpload called");
      console.log({ file });

      if (!file) {
        return;
      }

      // Validate file type
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
      if (!allowedTypes.includes(file.type)) {
        this.sweetAlert("error", "Only image files (JPEG, PNG, GIF) are allowed.", false);
        return;
      }

      // Validate file size (max 5MB)
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        this.sweetAlert("error", "File size should not exceed 5MB.", false);
        return;
      }

      // Check max count
      if (this.UploadedFiles.length >= this.CategoryMaxCount) {
        this.sweetAlert("error", "Maximum file upload limit reached.", false);
        return;
      }

      // Read file as base64
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64String = e.target.result.split(',')[1]; // Remove data:image/...;base64, prefix
        
        this.UploadedFiles.push({
          FileName: file.name,
          FileType: file.type,
          FileSize: file.size,
          FileBase64: base64String,
          FilePreview: e.target.result
        });

        console.log("File uploaded:", file.name);
        console.log("Total uploaded files:", this.UploadedFiles.length);
      };
      reader.readAsDataURL(file);
    },
    removeUploadedFile(index) {
      console.log("removeUploadedFile called");
      console.log({ index });
      if (index > -1) {
        this.UploadedFiles.splice(index, 1);
      }
      console.log("UploadedFiles =" + JSON.stringify(this.UploadedFiles.map(f => f.FileName)));
    },
    getCurrentDateTime(status) {
      console.log("getCurrentDateTime called");

      console.log({ status });
      this.Status = status;

      // Get new date
      var dateObj = new Date();

      var temp_date = String(dateObj.getDate()).padStart(2, "0");
      var month = String(dateObj.getMonth() + 1).padStart(2, "0");
      var year = dateObj.getFullYear();

      // Get Current Date
      var current_date = year + "-" + month + "-" + temp_date;

      // var temp_hour = String(dateObj.getHours()).padStart(2, "0") % 12;
      // var hour = temp_hour ? temp_hour : 12;
      var hour = String(dateObj.getHours()).padStart(2, "0");
      var minute = String(dateObj.getMinutes()).padStart(2, "0");
      var second = String(dateObj.getSeconds()).padStart(2, "0");

      // Get Current Time
      var current_time = hour + ":" + minute + ":" + second;

      // Get Current AM/PM
      // var current_am_pm = dateObj.getHours() >= 12 ? "pm" : "am";

      console.log({ current_date }, { current_time });

      this.CurrentDate = current_date;
      this.CurrentTime = current_time;
      // this.CurrentAmPm = current_am_pm;

      var current_date_time = current_date + " " + current_time;

      this.CurrentDateTime = current_date_time;

      var tr = this.recognitionDetails;
      if (tr.StartDate1 != "" && tr.EndDate1 != "" && current_date_time != "") {
        this.getDeadlineDetails(tr.StartDate1, tr.EndDate1);
      }
    },
    getDeadlineDetails(start_date_txt, end_date_txt) {
      console.log("getDeadlineDetails called");

      console.log({ start_date_txt }, { end_date_txt });

      // this.CurrentDateTime = "2023-08-01 00:00:00";
      var current_date_time = Date.parse(this.CurrentDateTime);
      console.log({ current_date_time });

      // Np-Recognition Start Date
      var temp_start_date_time = start_date_txt;
      // temp_start_date_time = "2023-08-01 00:00:01";
      var start_date_time = Date.parse(temp_start_date_time);
      console.log({ temp_start_date_time }, { start_date_time });

      if (start_date_time <= current_date_time) {
        console.log("Opened");
        this.StartDateFlag = true;
      } else {
        console.log("Closed");
      }

      // Np-Recognition End Date

      var temp_end_date_time = end_date_txt;
      var end_date_time = Date.parse(temp_end_date_time);
      console.log({ temp_end_date_time }, { end_date_time });

      if (end_date_time > current_date_time) {
        console.log("Opened");
        this.EndDateFlag = true;
      } else {
        console.log("Closed");
      }

      console.log("StartDateFlag = ", this.StartDateFlag);
      console.log("EndDateFlag = ", this.EndDateFlag);
      if (this.StartDateFlag && this.EndDateFlag) {
        this.confirmAlert(status);
      } else {
        this.deadlineAlert();
      }
    },
    deadlineAlert() {
      console.log("deadlineAlert called");
      var tr = this.recognitionDetails;
      var htmlTxt = "";
      htmlTxt += "<h2 style='color:red;'> Data Failed to Save ! </h2>";
      htmlTxt += "<br/><h3> Deadline Passed at ";
      htmlTxt += "<br/> <b> " + tr.EndDateTxt + " </b> </h3>";

      Swal.fire({
        title: "Sorry !",
        text: "",
        icon: "warning",
        html: htmlTxt,
      });
    },
    confirmAlert(status) {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      // var status = this.Status;
      console.log({ status });
      var tr = this.recordData;
      var tr1 =
        this.LomDetails.President != "" ? this.LomDetails.President : null;
      var president_id = tr1 == null ? null : tr1.LomPresidentMemberId;

      var MemberId = tr.CategoryType == 2 ? this.MemberId : president_id;
      var n1 = this.AllProject.length;
      var n2 = this.UploadedFiles.length;
      var totalAttachments = n1 + n2;
      console.log({ MemberId }, { n1 }, { n2 }, { totalAttachments });

      if (MemberId > 0 && totalAttachments > 0 && status != "") {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm(status);
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message;
        if (MemberId < 0 || MemberId == null || MemberId == undefined) {
          message = "Member Deails not found.";
          this.sweetAlert("error", message, false);
        }
        if (totalAttachments == 0) {
          message = "Atleast one Attachment is reqired.";
          this.sweetAlert("error", message, false);
        }
      }
    },
    submitForm(status) {
      console.log("submitForm is called");
      console.log({ status });

      var tr = this.recordData;
      var tr1 =
        this.LomDetails.President != "" ? this.LomDetails.President : null;
      var president_id = tr1 == null ? null : tr1.LomPresidentMemberId;

      var MemberId = tr.CategoryType == 2 ? this.MemberId : president_id;

      var n1 = this.AllProject.length;
      var n2 = this.UploadedFiles.length;
      var totalAttachments = n1 + n2;
      console.log({ MemberId }, { n1 }, { n2 }, { totalAttachments });

      if (MemberId > 0 && totalAttachments > 0) {
        this.OverlayLoadingFlag = true;
        if (status == 4) {
          this.SaveFlag = true;
        } else {
          this.SubmitFlag = true;
        }
        var upload = {
          UserInterface: 1,
          Category: tr.CategoryId,
          Description: this.Description,
          MemberId: MemberId,
          AllProject: this.AllProject,
          UploadedFiles: this.UploadedFiles,
          ActiveStatus: status,
        };
        console.log("upload=" + JSON.stringify(upload));

        this.ResultFlag = false;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;

        var add_url = server_url + "api/recognition/store";
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.OverlayLoadingFlag = false;
            if (status == 4) {
              thisIns.SaveFlag = false;
            } else {
              thisIns.SubmitFlag = false;
            }

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);
            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.ResultFlag = true;
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.OverlayLoadingFlag = false;
            if (status == 4) {
              thisIns.SaveFlag = false;
            } else {
              thisIns.SubmitFlag = false;
            }
          });
      }
    },
  },

  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
// Professional Recognition Form Styles
.professional-recognition-form {
  background-color: #f5f7fa;
  min-height: 100vh;

  // Professional Overlay
  .professional-overlay {
    .loading-container {
      text-align: center;
      color: white;

      .loading-text {
        font-size: 1.1rem;
        font-weight: 500;
        margin: 0;
      }
    }
  }

  // Main Form Container
  .main-form-container {
    border-radius: 12px !important;
    overflow: hidden;
    background: white;
    box-shadow: 0 6px 30px rgba(0, 0, 0, 0.1) !important;
  }

  // Professional Header Styles
  .professional-form-header {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-bottom: 1px solid #e3f2fd;

    .header-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .title-section {
        flex: 1;

        .main-title-wrapper {
          display: flex;
          align-items: center;

          .title-text {
            .form-main-title {
              font-size: 1.8rem;
              font-weight: 700;
              color: #2c3e50;
              margin: 0;
              font-family: "Roboto", sans-serif;
              line-height: 1.2;
            }
          }
        }
      }

      .action-buttons {
        .action-btn {
          font-weight: 500;
          text-transform: none;
          padding: 0 20px;
          height: 40px;

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }
        }
      }
    }
  }

  // Form Content Styles
  .form-main-content {
    background: #f5f7fa;
  }

  // Form Loading
  .form-loading-section {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;

    .loading-wrapper {
      text-align: center;

      .loading-text {
        font-size: 1.1rem;
        color: #666;
        font-weight: 500;
        margin: 0;
      }
    }
  }

  // Professional Form
  .professional-form {
    .form-content-wrapper {
      .details-card,
      .input-card,
      .attachments-card,
      .submit-card {
        border-radius: 12px !important;
        border: 1px solid #e0e0e0;
      }
    }
  }

  // Details Cards
  .details-card,
  .input-card,
  .attachments-card {
    .details-header {
      background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
      border-bottom: 1px solid #e0e0e0;
      padding: 1.5rem;

      .section-title {
        font-size: 1.3rem;
        font-weight: 600;
        color: #2c3e50;
      }
    }

    .detail-item {
      margin-bottom: 1rem;

      .detail-label {
        font-size: 0.85rem;
        font-weight: 600;
        color: #666;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 0.25rem;
        display: block;
      }

      .detail-value {
        font-size: 1rem;
        color: #2c3e50;
        font-weight: 500;
        margin: 0;
        line-height: 1.4;
      }
    }
  }

  // Input Section
  .input-section {
    .input-label {
      font-size: 1rem;
      font-weight: 600;
      color: #2c3e50;
      margin-bottom: 0.5rem;

      .required-indicator {
        color: #f44336;
        margin-right: 0.25rem;
      }
    }

    .member-selection-item,
    .member-dropdown-item {
      display: flex;
      align-items: center;

      .member-avatar {
        border-radius: 50%;
        border: 2px solid #e0e0e0;
        object-fit: cover;
      }
    }
  }

  // Member Details Card
  .member-details-card {
    background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
    border: 2px solid #e3f2fd !important;
    border-radius: 12px !important;

    .member-detail-item {
      .member-label {
        font-size: 0.75rem;
        font-weight: 600;
        color: #666;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 0.25rem;
        display: block;
      }

      .member-value {
        font-size: 0.95rem;
        color: #2c3e50;
        font-weight: 500;
        margin: 0;
        line-height: 1.4;
      }
    }
  }

  // Attachments Card
  .attachments-card {
    .attachments-header-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .attachments-title-section {
        display: flex;
        align-items: center;
      }

      .add-attachment-btn {
        &:hover {
          transform: scale(1.1);
        }
      }
    }

    .attachment-item-card {
      border-radius: 8px !important;
      position: relative;
      transition: transform 0.2s, box-shadow 0.2s;
      border: 1px solid #e0e0e0 !important;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
      }

      .attachment-actions {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        z-index: 2;

        .delete-btn {
          background-color: rgba(255, 255, 255, 0.9);

          &:hover {
            background-color: rgba(244, 67, 54, 0.1);
          }
        }
      }

      .event-images {
        .images-grid {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 0.5rem;

          .event-image {
            border-radius: 4px;
            border: 1px solid #e0e0e0;
            object-fit: cover;
            transition: transform 0.2s;

            &:hover {
              transform: scale(1.05);
            }
          }
        }
      }

      .event-details {
        .detail-row {
          display: flex;
          align-items: center;
          font-size: 0.85rem;

          .detail-value {
            color: #2c3e50;
            font-weight: 500;
          }
        }
      }
    }

    .no-attachments-state {
      text-align: center;
      padding: 3rem;
    }
  }

  // File Upload Styles
  .file-preview {
    .uploaded-image {
      border: 2px solid #e0e0e0;
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .file-details {
    .detail-row {
      display: flex;
      align-items: center;
      font-size: 0.85rem;

      .detail-value {
        color: #2c3e50;
        font-weight: 500;
      }

      .text-truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  // Submit Section
  .submit-section {
    margin-top: 2rem;

    .submit-card {
      border: 2px solid #e3f2fd;
      background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);

      .submit-info {
        .submit-title {
          font-size: 1.4rem;
          font-weight: 600;
          color: #2c3e50;
          margin: 0;
        }

        .submit-description {
          color: #666;
          margin: 0.5rem 0 0 0;
          font-size: 1rem;
        }
      }

      .action-buttons {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 0.5rem;

        .submit-btn {
          min-width: 150px;
          font-weight: 600;
          text-transform: none;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
          }
        }
      }
    }
  }

  // Responsive Design
  @media (max-width: 768px) {
    .main-form-container {
      margin: 0.5rem;
      border-radius: 8px !important;
    }

    .professional-form-header {
      padding: 1rem !important;

      .header-content {
        flex-direction: column;
        gap: 1rem;
        align-items: flex-start;

        .title-section .main-title-wrapper .title-text .form-main-title {
          font-size: 1.3rem;
        }

        .action-buttons {
          align-self: flex-start;
        }
      }
    }

    .form-main-content {
      padding: 1rem !important;
    }

    .details-header {
      padding: 1rem !important;

      .section-title {
        font-size: 1.1rem !important;
      }
    }

    .action-buttons {
      flex-direction: column;
      width: 100%;

      .submit-btn {
        width: 100%;
        margin: 0.25rem 0 !important;
      }
    }

    .member-details-card {
      .v-avatar {
        size: 80px !important;
      }
    }
  }
}
</style>
